/**
 * Which mcpjam host style each sphinx client wears.
 *
 * mcpjam shipped a per-host chat chrome registry (`lib/client-styles`) —
 * palette, fonts, bubble family, brand mark and thinking indicator — and used
 * it to make a Claude column look like Claude and a ChatGPT column like
 * ChatGPT. The Playground's dispatch columns render a REAL client's answer, so
 * they wear that client's chrome; only the `direct` column stays in the sphinx
 * house style (`DEFAULT_HOST_STYLE`, id `"mcpjam"`).
 *
 * The Claude Code and Codex surfaces borrow their vendor's chrome the way the
 * registry already does (`CLAUDE_CODE_HOST_STYLE` borrows Claude's,
 * `CODEX_HOST_STYLE` borrows ChatGPT's). The two direct-API clients have no
 * chat UI of their own, so they wear their vendor's.
 */
import { DEFAULT_HOST_STYLE, type HostStyleId } from "@/lib/client-styles";
import type { TargetId } from "@/shared/sphinx";

const CLIENT_HOST_STYLE: Record<TargetId, HostStyleId> = {
  "claude-desktop": "claude",
  "claude-cowork": "claude",
  "claude-web": "claude",
  "claude-code": "claude-code",
  "claude-code-desktop": "claude-code",
  "anthropic-api": "claude",
  "chatgpt-desktop": "chatgpt",
  "chatgpt-web": "chatgpt",
  "codex-desktop": "codex",
  "openai-api": "chatgpt",
};

/** Host style for a client id; the sphinx house style for anything else. */
export const clientHostStyle = (target: string): HostStyleId =>
  (CLIENT_HOST_STYLE as Record<string, HostStyleId>)[target] ??
  DEFAULT_HOST_STYLE.id;
